import { Directive, forwardRef } from '@angular/core';
import { Validator, AbstractControl, NG_VALIDATORS } from '@angular/forms';

@Directive({
  selector: '[appConfigNumberPattern][ngModel], [appConfigNumberPattern][formControl]',
  providers: [{
    provide: NG_VALIDATORS, multi: true,
    useExisting: forwardRef(() => ConfigNumberPatternValidator),
  }],
})
export class ConfigNumberPatternValidator implements Validator {
  numberPattern = /^\d+(\.\d{1,2})?$/;
  validate(control: AbstractControl) {

    if (isNaN(parseFloat(control.value))) {
      return { numberPattern: 1};
    }

    return this.numberPattern.test(control.value)
    ? null : { numberPattern: control.value };

  }
}



// WEBPACK FOOTER //
// ./src/app/shared-services/config-number-pattern.validator.ts